// Token storage for the web client. Mirrors the role of iOS Keychain +
// AppState.accessToken: the access token is short-lived (15 min) and the refresh
// token (7 days) is used for silent renewal. The browser has no Keychain, so we
// persist to localStorage — acceptable for this app's threat model and matched
// to the plan's "httpOnly-ish localStorage fallback". A small subscriber set lets
// React re-render on login/logout without a global state library.

const ACCESS_KEY = "edupause.accessToken";
const REFRESH_KEY = "edupause.refreshToken";

type Listener = () => void;
const listeners = new Set<Listener>();

function notify() {
  for (const l of listeners) l();
}

export const tokenStore = {
  get access(): string | null {
    return localStorage.getItem(ACCESS_KEY);
  },
  get refresh(): string | null {
    return localStorage.getItem(REFRESH_KEY);
  },
  get isAuthenticated(): boolean {
    return localStorage.getItem(REFRESH_KEY) != null;
  },
  setTokens(access: string, refresh?: string) {
    localStorage.setItem(ACCESS_KEY, access);
    if (refresh) localStorage.setItem(REFRESH_KEY, refresh);
    notify();
  },
  setAccess(access: string) {
    localStorage.setItem(ACCESS_KEY, access);
    notify();
  },
  clear() {
    localStorage.removeItem(ACCESS_KEY);
    localStorage.removeItem(REFRESH_KEY);
    notify();
  },
  subscribe(l: Listener): () => void {
    listeners.add(l);
    return () => listeners.delete(l);
  },
};
